// @cgtrader/cgt-viewer publishes no depth render mode and no access to its three.js
// objects, so the depth pass reaches into the instance for them. They are real three
// objects (from `three/webgpu`, which is what the viewer builds its scene with) but are
// absent from the package typings, so a viewer upgrade could rename them without a type
// error. This is the single place that would break, and it returns null rather than
// throwing so a rename degrades to "no depth map" instead of a broken Render button.
//
// Worth replacing with a public `renderDepthMap()` (or scene access) upstream.
export const getViewerInternals = (viewer) => {
  const scene = viewer?.scene
  const camera = viewer?.camera?.instance
  // eslint-disable-next-line no-underscore-dangle -- the viewer's own field name
  const renderer = viewer?.renderer?._instance

  const isUsable = Boolean(scene?.isScene)
    && Boolean(camera?.isPerspectiveCamera)
    && typeof renderer?.renderAsync === 'function'
    && typeof renderer?.readRenderTargetPixelsAsync === 'function'

  return isUsable ? { scene, camera, renderer } : null
}

/**
 * The loaded model's group. The viewer names it after the model id it reports through
 * the public getLoadedModels(), which is what keys it apart from the lights, the ground
 * plane and the transform gizmo that share the scene.
 */
export const getModelObject = (viewer, scene) => {
  const modelId = viewer?.getLoadedModels?.()?.[0]?.id

  return modelId ? scene.getObjectByName(modelId) : null
}
